import React, { useState } from "react";
import "./BuySellButtons.scss";
import { useNavigate, useLocation } from "react-router-dom";

const BuySellButtons = () => {
    const [activeButton, setActiveButton] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const income = location.state?.data; // Access the passed data safely
    const handlePress = (buttonName) => {
        setActiveButton(buttonName);
        if (buttonName === 'buy') {
            navigate("/olx_buy", {
                state: {data:income },
              });
        } else if(buttonName === 'sell'){
            navigate("/olx_sell", {
                state: {data:income },
              });
        }else{
            navigate("/olx_transfer", {
                state: {data:income },
              });
        }

    };

    const handleRelease = () => {
        setActiveButton(null);
    };

    return (
        <div className="button-page-container">
            <div className="buttons-wrapper">
                <button
                    className={`blue-button ${activeButton === 'buy' ? 'clicked' : ''}`}
                    onTouchStart={() => handlePress('buy')}
                    onTouchEnd={handleRelease}
                    onMouseDown={() => handlePress('buy')}
                    onMouseUp={handleRelease}
                    onMouseLeave={handleRelease}
                >
                    Buy
                </button>

                <button
                    className={`blue-button ${activeButton === 'sell' ? 'clicked' : ''}`}
                    onTouchStart={() => handlePress('sell')}
                    onTouchEnd={handleRelease}
                    onMouseDown={() => handlePress('sell')}
                    onMouseUp={handleRelease}
                    onMouseLeave={handleRelease}
                >
                    Sell
                </button>

                <button
                    className={`blue-button ${activeButton === 'transfer' ? 'clicked' : ''}`}
                    onTouchStart={() => handlePress('transfer')}
                    onTouchEnd={handleRelease}
                    onMouseDown={() => handlePress('transfer')}
                    onMouseUp={handleRelease}
                    onMouseLeave={handleRelease}
                >
                    Transfer
                </button>
            </div>
        </div>
    );
};

export default BuySellButtons;